<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: "HPagination",
  
})
</script>
<template>
  <div class="h-pagination">
    <el-pagination @current-change="currentChangeEvent" :page-size="15" :current-page="currentPage"  background :layout="layout" :total="total" />
  </div>
</template>

<script lang="ts" setup name="HPagination">
  import {ref, defineProps, withDefaults, defineEmits} from "vue";

  const emit = defineEmits(["change"]);
  interface Props {
    total: number;
    currentPage: number;
    layout?: string
  }

  withDefaults(defineProps<Props>(), {
    total: 0,
    currentPage: 1,
    layout: "total, prev, pager, next"
  });

  /**
   * @description 页码改变触发事件
   * @param value
   */
  const currentChangeEvent = (value: number) => {
    emit("change", value);
  }

</script>

<style lang="scss">
.h-pagination {
  padding-right: 10px;
}
</style>